import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";

const AddNewRole = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    const errors = {};
    let isValid = true;

    RoleInputs.forEach((field) => {
      console.log("field>>", field);
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors", validationErrors);
      return;
    }

    showCustomAlert({
      title: "Success",
      text: "Are you sure you want to add this record?",
      confirmButtonText: "Role added successfully.",
      icon: "success",
      confirmButtonText: "OK",
      callback: async () => {
        try {
          setLoading(true);
          const payload = {
            role_name: formData.roleName,
            role_desc: formData.description,
            status: formData.status == "Active" ? 1 : 0,
          };

          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }

          const response = await axiosInstance.post("/role/create", payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });

          console.log("API Response:", response.data);
          // toastSuccess("Role added successfully!");

          if (response.status === 200) {
            navigate(ROUTES_NAVIGATION.ROLELIST); // Navigate after user clicks OK
          }
        } catch (error) {
          const errorMessage = error.response?.data?.message;
          showErrorAlert({
            title: "Something went wrong",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            callback: () => {
              console.log("Error alert confirmed");
            },
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const RoleInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: {
              required: true,
              pattern: /^[A-Za-z0-9 ]*$/,
              message: "Only alphabets and digits are allowed",
            },
          },
        ]
      : []),
    {
      name: "roleName",
      label: "Role Name",
      type: "text",
      required: true,
      placeholder: "Enter Role Name",
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
        maxLength: 25,
      },
    },

    {
      name: "description",
      label: "Description",
      placeholder: "Enter Role Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status Name",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Add New Role</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Role Details
            </span>
            <DynamicForm
              formConfig={RoleInputs}
              formData={formData}
              setFormData={setFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              onClick={handleSubmit}
              className="submit-btn"
              disabled={loading}
            >
              {"Submit"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AddNewRole;
